import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAffiliateClick, trackIntent } from '../utils/metaPixel';
interface FinalCTASectionProps {
  onOpenForm: () => void;
}
export function FinalCTASection({
  onOpenForm
}: FinalCTASectionProps) {
  return <section className="py-28 bg-white relative overflow-hidden" data-id="element-122">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 md:p-12 text-center border border-slate-200 shadow-sm relative overflow-hidden" data-id="element-124">
          {/* Subtle geometric accent */}
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10 pointer-events-none" data-id="element-125">
            <svg viewBox="0 0 100 100" className="w-full h-full text-gold fill-current" data-id="element-126">
              <pattern id="dots" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-127">
                <circle cx="2" cy="2" r="1.5" data-id="element-128" />
              </pattern>
              <rect x="0" y="0" width="100" height="100" fill="url(#dots)" data-id="element-129" />
            </svg>
          </div>

          <div className="relative z-10" data-id="element-130">
            <h2 className="text-3xl md:text-5xl font-bold font-serif text-navy mb-6 tracking-tight" data-id="element-131">
              Understand the reporting system before paying anyone to navigate
              it
            </h2>

            <p className="text-lg font-medium text-slate-600 mb-10 max-w-2xl mx-auto leading-[1.75]" data-id="element-132">
              The strongest consumer position begins with documentation,
              visibility, and knowledge of federal reporting rights. Start with
              the same framework used to analyze bureau inconsistencies across
              public complaint records.
            </p>

            <div className="flex flex-col items-center justify-center space-y-6" data-id="element-133">
              <button onClick={() => {
              trackIntent('final_cta_playbook');
              onOpenForm();
            }} className="w-full sm:w-auto bg-emerald hover:bg-emerald-600 text-white px-10 py-4 rounded-lg font-bold text-lg transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5 inline-flex items-center justify-center" data-id="element-134">
                Read The Playbook
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-135" />
              </button>

              <p className="text-sm text-slate-500" data-id="element-136">
                Already understand the framework? Explore monitoring
                infrastructure at{' '}
                <a href="https://procreditwatch.com/redirect.asp?guid=ZMEA756999SU" target="_blank" rel="noopener sponsored" data-product="procreditwatch" onClick={() => trackAffiliateClick('procreditwatch', 'ProCreditWatch')} className="text-emerald-700 hover:text-emerald-600 underline underline-offset-4 transition-colors font-medium" data-id="element-137">
                  ProCreditWatch
                </a>
                .
              </p>

              <p className="text-xs text-slate-400 italic mt-4" data-id="element-138">
                Educational tools only. No guaranteed outcomes or score
                increases.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="mt-20 text-center" data-id="element-139">
          <div className="inline-block relative" data-id="element-140">
            <div className="absolute top-0 left-0 right-0 h-px bg-gold/30" data-id="element-141"></div>
            <span className="block py-3 px-8 font-mono text-sm tracking-widest text-gold uppercase font-medium" data-id="element-142">
              The goal is not panic. It is visibility.
            </span>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gold/30" data-id="element-143"></div>
          </div>
        </div>
      </div>
    </section>;
}